module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"description":"Estas são as chaves que você precisa para fazer testes na nossa API. Para transações com recebíveis reais, use as chaves do ambiente de Produção."},"en-US":{"description":"These are the keys you need to test our API. For transactions with real receivables, use keys from the Production environment."}}')
  delete Component.options._Ctor
}
